import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "./Section_8.css"; // Import the CSS file

const ImageCarousel = () => {
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    // Fetch images from the backend
    fetch("https://urbancasabackendfiles.onrender.com/api/carousel") // Change to your backend URL if deployed
      .then((response) => response.json())
      .then((data) => setSlides(data))
      .catch((error) => console.error("Error fetching carousel images:", error));
  }, []);

  return (
    <Swiper
      modules={[Autoplay, EffectFade, Navigation, Pagination]}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      effect="fade"
      navigation
      pagination={{ clickable: true }}
      className="carousel-container"
    >
      {slides.map((slide, index) => (
        <SwiperSlide key={index}>
          <div
            className="carousel-slide"
            style={{ backgroundImage: `url(${slide.url})` }}
          >
            <div className="carousel-text">{slide.text}</div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ImageCarousel;
